/**
 * إخلاء المسؤولية النظامي — نص واحد لا يُصاغ في مكان آخر.
 *
 * لماذا يوجد:
 *   نظام المقيّمين المعتمدين (م/٤٣ · ١٤٣٣هـ) يعرّف التقييم بأنه «تحديد القيمة
 *   العادلة للعقارات»، ويمنع مزاولته بلا ترخيص. نطاق يُخرج تقديراً آلياً لا
 *   تقرير تقييم، والتصريح بهذا الفرق **شرط إطلاق** لا تحسيناً.
 *
 * قواعد ملزمة:
 *   ١. يظهر تحت كل رقم تقديري يقرأه المستخدم — لا في تذييل بعيد.
 *   ٢. يوجّه إلى البديل الصحيح (مقيّم مرخّص). منتج يقول متى تحتاج غيره يُوثق به أكثر.
 *   ٣. لا يستخدم لوناً تحذيرياً — هذه ليست حالة خطأ، بل تصريح دائم.
 */

import { color } from '@/design/tokens';

/** النص الرسمي. مصدر واحد — أي تغيير هنا يسري على كل موضع. */
export const DISCLAIMER_TEXT =
  'الأرقام المعروضة تقديرات آلية مبنية على صفقات عقارية مسجّلة رسمياً. ' +
  'هي ليست تقرير تقييم معتمد، ولا تصلح للأغراض البنكية أو التمويلية أو ' +
  'القضائية أو النظامية. للحصول على تقييم معتمد، راجع مقيّماً مرخّصاً من ' +
  'الهيئة السعودية للمقيمين المعتمدين.';

/** النسخة المختصرة — للمواضع الضيقة (بطاقة، جدول، تذييل تقرير). */
export const DISCLAIMER_SHORT =
  'تقدير آلي مبني على صفقات مسجّلة رسمياً — وليس تقرير تقييم معتمد.';

export function Disclaimer({ variant = 'full' }: { variant?: 'full' | 'short' }): JSX.Element {
  return (
    <p
      data-testid="legal-disclaimer"
      style={{
        marginTop: 18,
        paddingTop: 14,
        borderTop: `1px solid ${color.hairline}`,
        fontSize: 11.5,
        lineHeight: 1.85,
        color: color.textSubtle,
      }}
    >
      {variant === 'short' ? DISCLAIMER_SHORT : DISCLAIMER_TEXT}
    </p>
  );
}
